import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as ErrorMessage from "../../common/errorMessage"
import * as Regex from "../../common/regex"
import * as Alert from "../../services/sweetalertService"
import * as Constants from "../../common/constants"
import * as CommonFunction from "../../common/function"

import FormSectionTitle from "../shared/formSectionTitle"
import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormRadioButton from "../shared/formRadioButton"
import FormDatePickerTextBox from "../shared/formDatePickerTextBox"
import FormTimeTextBox from "../shared/formTimeTextBox"
import FormAmountTextBox from "../shared/formAmountTextBox"
import FormDropdownArray from "../shared/formDropdownArray"
import { useDispatch, batch } from "react-redux"
import {
  controlEditBenefit,
  updateValidFormData,
  pageIncrement,
  updateClickedNext,
  updateFormIsValid,
  updateUiData,
} from "../../redux/actions"
import { Row, Col, Form } from "react-bootstrap"
import EditBenefitImg from "../../content/img/editBenefit.png"

const LossDetails = ({ claimData, uiData }) => {
  const {
    pageNumber,
    editBenefits,
    clickedNext,
    occupationList,
    hideHeaderFooter,
  } = uiData
  const formName = Constants.lossDetailsFormName
  const dispatch = useDispatch()
  const formRef = React.useRef()

  //   const formClickedNext = clickedNext[formName]

  const lossDetailsSchema = Yup.object().shape({
    claimAmount: Yup.string()
      .trim()
      .required(ErrorMessage.claimAmount)
      .matches(Regex.amountpattern, ErrorMessage.claimAmount),
    claimDetail: Yup.string()
      .trim()
      .required(ErrorMessage.claimDetail),
    dateOfAccident: Yup.date().required(ErrorMessage.dateOfAccident),
    timeOfAccident: Yup.string()
      .trim()
      .required(ErrorMessage.timeOfAccident)
      .matches(Regex.timepattern, ErrorMessage.timeOfAccident)
      .test("timeOfAccident", ErrorMessage.futureTimeErrorMsg, value => {
        if ((formRef.current.values.dateOfAccident, value)) {
          return CommonFunction.notFutureDatime(
            formRef.current.values.dateOfAccident,
            value
          )
        } else {
          return true
        }
      }),

    locationOfAccident: Yup.string()
      .trim()
      .required(ErrorMessage.locationOfAccident),
    descriptionOfAccident: Yup.string()
      .trim()
      .required(ErrorMessage.descriptionOfAccident),
    noticeDate: Yup.date()
      .required(ErrorMessage.noticeDate)
      .when(
        "dateOfAccident",
        (dateOfAccident, schema) =>
          dateOfAccident &&
          schema.min(dateOfAccident, ErrorMessage.noticeDateEarlierThanAccident)
      ),
    noticeTime: Yup.string()
      .trim()
      .required(ErrorMessage.noticeTime)
      .matches(Regex.timepattern, ErrorMessage.noticeTime)
      .test("noticeTime", ErrorMessage.futureTimeErrorMsg, value => {
        if (formRef.current.values.noticeDate && value) {
          return CommonFunction.notFutureDatime(
            formRef.current.values.noticeDate,
            value
          )
        } else {
          return true
        }
      })
      .test("noticeTime", ErrorMessage.noticeDateEarlierThanAccident, value => {
        if (
          formRef.current.values.dateOfAccident &&
          formRef.current.values.timeOfAccident &&
          formRef.current.values.noticeDate &&
          value
        ) {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.dateOfAccident,
            formRef.current.values.timeOfAccident,
            formRef.current.values.noticeDate,
            value
          )
        } else {
          return true
        }
      }),
    whoInform: Yup.string()
      .trim()
      .required(ErrorMessage.whoInform),
    actionTaken: Yup.string()
      .trim()
      .required(ErrorMessage.actionTaken),
    prevention: Yup.string()
      .trim()
      .required(ErrorMessage.prevention),
    liableForAccident: Yup.string()
      .trim()
      .required(ErrorMessage.liableForAccident),
  })

  const handleEditBenefit = () => {
    dispatch(controlEditBenefit(formName))
  }

  // let witnessList = []
  const [witnessList, setWitnessList] = React.useState([])
  //event
  function addWitnessEvent(name, address) {
    if (name.trim() && address.trim()) {
      let index = new Date().getTime().toString()

      let copyOfWitnessList = Object.assign([], witnessList)

      copyOfWitnessList.push({
        index: index,
        witnessName: name,
        witnessAddress: address,
      })

      setWitnessList(copyOfWitnessList)
      formRef.current.setFieldValue("witnessName", "")
      formRef.current.setFieldValue("witnessAddress", "")
    } else {
      Alert.fillAllWitnessItemAlert()
    }
  }

  function removeWitnessEvent(index) {
    let copyOfWitnessList = Object.assign([], witnessList)
    let indexToRemove = copyOfWitnessList.findIndex(x => x.index === index)
    copyOfWitnessList.splice(indexToRemove, 1)
    setWitnessList(copyOfWitnessList)
  }

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimLiabilityDetail"])}
      enableReinitialize={true}
      validationSchema={lossDetailsSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, isValid, values, errors, handleBlur }) => (
        <div>
          <Row
            className={
              "col-xs-12 bigScreenNarrowing form-group ReviewChoosedDetailDiv " +
              (pageNumber === 5 && !editBenefits[formName] ? "" : "hide")
            }
          >
            <div className="col-md-10 col-8 summaryBenefit">
              <b> {formName} </b>
            </div>
            <div className="col-md-2 col-4 row noMarginLeftRightSmallScreen">
              <div
                className="col-12 pr-0"
                onClick={() => {
                  handleEditBenefit()
                }}
                onKeyDown={() => {
                  handleEditBenefit()
                }}
                tabIndex="0"
                role="button"
              >
                <img className="editBtn" src={EditBenefitImg} alt=""></img>
              </div>
            </div>
          </Row>
          <FormikForm onSubmit={handleSubmit}>
            <Row
              className={
                pageNumber === 3 || (pageNumber === 5 && editBenefits[formName])
                  ? ""
                  : "hide"
              }
            >
              <div
                className={
                  "title text-center " +
                  (pageNumber === 3 ? "" : "hide") +
                  " " +
                  (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
                }
              >
                Submit online liability claim
              </div>
              <Row
                className={
                  "containerBody " +
                  (pageNumber === 5
                    ? "blueBG summaryContainerBody mb-4 "
                    : "marginTop3x")
                }
              >
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="formContainer"
                >
                  <div
                    className={
                      "horizontal-align marginBottom1x " +
                      (pageNumber === 3 ||
                      (pageNumber === 5 && editBenefits[formName])
                        ? ""
                        : "hide")
                    }
                  >
                    <Col xs={12} md={12}>
                      <div
                        className={
                          "titleText " + (pageNumber === 5 ? "hide" : "")
                        }
                      >
                        Loss Details
                      </div>
                    </Col>
                  </div>
                  {
                    <Row
                      className={
                        "form-group " + (editBenefits[formName] ? "" : "hide")
                      }
                    >
                      <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                        <p>{formName}</p>
                      </div>
                      <div className="col-md-3 col-5 marginTop10px">
                        <div
                          className="cursorPointer"
                          role="button"
                          tabIndex="0"
                          onClick={() => dispatch(controlEditBenefit(formName))}
                          onKeyDown={() =>
                            dispatch(controlEditBenefit(formName))
                          }
                        >
                          <p className="doneEdit">DONE EDIT</p>
                        </div>
                      </div>
                    </Row>
                  }
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Details of Claims"}
                    maxLength={100}
                    name="claimDetail"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc="Date of Accident"
                    name="dateOfAccident"
                    component={FormDatePickerTextBox}
                  />
                  <Field
                    textDesc="Time of Accident (HH:mm)"
                    name="timeOfAccident"
                    component={FormTimeTextBox}
                  />
                  <Field
                    textDesc={"Location of Accident"}
                    maxLength={100}
                    name="locationOfAccident"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"Description of Accident"}
                    maxLength={100}
                    name="descriptionOfAccident"
                    component={FormTextbox}
                    toUpperCase={false}
                  />

                  <br />
                  <FormSectionTitle
                    text={"When did you receive notice of the accident?"}
                  />

                  <Field
                    textDesc="Date"
                    name="noticeDate"
                    component={FormDatePickerTextBox}
                    disableBefore={"dateOfAccident"}
                  />
                  <Field
                    textDesc="Time (HH:mm)"
                    name="noticeTime"
                    component={FormTimeTextBox}
                  />
                  <Field
                    textDesc={
                      "From whom did you receive notice of the accident?"
                    }
                    maxLength={100}
                    name="whoInform"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"Is the notification in writing?"}
                    name="writingNotice"
                    component={FormRadioButton}
                  />

                  {/* Maybe can change textarea */}
                  <Field
                    textDesc={
                      "Describe in detail, your immediate actions taken upon notification of the incident."
                    }
                    maxLength={300}
                    name="actionTaken"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"How could you have prevented the incident?"}
                    maxLength={300}
                    name="prevention"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={
                      "State in your opinion whether you are liable for the incident and reasons."
                    }
                    maxLength={300}
                    name="liableForAccident"
                    component={FormTextbox}
                    toUpperCase={false}
                  />

                  <br />
                  <FormSectionTitle
                    text={
                      "If accident arose from the negligence of one of your employee / you and / or your family members? (if applicable)"
                    }
                  />
                  <Field
                    textDesc={"Name"}
                    maxLength={100}
                    name="thirdPartyName"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Address"}
                    maxLength={100}
                    name="thirdPartyAddress"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"Occupation"}
                    name="thirdPartyOccupation"
                    component={FormDropdownArray}
                    propertyName={"Occupation"}
                    dropdownItem={occupationList}
                  />
                  {values.thirdPartyOccupation &&
                    values.thirdPartyOccupation === "Others" && (
                      <>
                        {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                        <Field
                          textDesc={"Disable Auto Complete"}
                          name="disableAutoComplete2"
                          component={FormFieldDisableAutoComplete}
                        />
                        <Field
                          textDesc={"Other occupation"}
                          maxLength={50}
                          name="thirdPartyOtherOccupation"
                          component={FormTextbox}
                          toUpperCase={false}
                        />
                      </>
                    )}

                  <Field
                    textDesc={"What was your employee engaged to do?"}
                    maxLength={300}
                    name="employeeDo"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"What act of negligence is alleged against him?"}
                    maxLength={300}
                    name="allegedAgainst"
                    component={FormTextbox}
                    toUpperCase={false}
                  />

                  <br />
                  <FormSectionTitle
                    text={
                      "Please provide name and address of every witness and every other person who was present"
                    }
                  />
                  <Field
                    textDesc={"Name"}
                    maxLength={100}
                    name="witnessName"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Address"}
                    maxLength={100}
                    name="witnessAddress"
                    component={FormTextbox}
                    toUpperCase={false}
                  />

                  <Form.Group>
                    <Row>
                      <Col md="7" lg="7" className="textforinput marginTop10px">
                        <p className={witnessList.length > 0 ? "" : "hide"}>
                          <b>Witness List</b>
                        </p>
                      </Col>
                      <Col
                        md="5"
                        lg="5"
                        className="marginTop10px"
                        id="divDescMake"
                        align="right"
                        style={{ lineHeight: "50px" }}
                      >
                        <div
                          className="btn btn-success btn-round btnAddItem"
                          onClick={() => {
                            addWitnessEvent(
                              values.witnessName,
                              values.witnessAddress
                            )
                          }}
                          onKeyDown={() => {
                            addWitnessEvent(
                              values.witnessName,
                              values.witnessAddress
                            )
                          }}
                          style={{ width: "80%" }}
                          role="button"
                          tabIndex="0"
                        >
                          <span id="btnAddItem">
                            <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                            &nbsp;Add
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group>
                    <Row className={witnessList.length > 0 ? "" : "hide"}>
                      <Col className="table-responsive">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col" colSpan="2">
                                Address
                              </th>
                              <th scope="col">Remove</th>
                            </tr>
                            {witnessList.map(item => (
                              <tr key={item.index}>
                                <td>{item.witnessName}</td>
                                <td colSpan="2">{item.witnessAddress}</td>
                                <td>
                                  <div
                                    className="btn btn-danger btn-fab btn-fab-mini btn-round"
                                    style={{ paddingTop: "7px" }}
                                    onClick={() => {
                                      removeWitnessEvent(item.index)
                                    }}
                                    onKeyDown={() => {
                                      removeWitnessEvent(item.index)
                                    }}
                                    role="button"
                                    tabIndex="0"
                                  >
                                    <i
                                      className="fa fa-minus"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </Form.Group>

                  <Field
                    textDesc={"Amount Claimed(SGD)"}
                    maxLength={14}
                    name="claimAmount"
                    component={FormAmountTextBox}
                  />
                </Col>
              </Row>
            </Row>
            <HandleFormValidation
              thisPageClickedNext={clickedNext[3]}
              reviewPageClickedNext={clickedNext[5]}
              formRef={formRef}
              values={values}
              thisPageNumber={3}
              dispatch={dispatch}
              witnessList={witnessList}
              formName={formName}
            />
          </FormikForm>
        </div>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  witnessList,
  formName,
}) => {
  React.useEffect(() => {
    if (thisPageClickedNext || reviewPageClickedNext) {
      formRef.current.validateForm().then(errors => {
        //console.log(errors)
        batch(() => {
          if (
            Object.entries(errors).length === 0 &&
            !values.witnessName.trim() &&
            !values.witnessAddress.trim()
          ) {
            // if (Object.entries(errors).length === 0 && witnessList.length > 0) {
            // console.log("PASS")

            dispatch(updateValidFormData("claimLiabilityDetail", values))
            dispatch(
              updateValidFormData("claimLiabilityWitnessList", witnessList)
            )
            if (thisPageClickedNext) {
              dispatch(pageIncrement())
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
              if (values.witnessName.trim() || values.witnessAddress.trim()) {
                Alert.pleaseAddWitnessBeforeNext()
              }
            } else {
              dispatch(updateFormIsValid(formName, false))
              if (values.witnessName.trim() || values.witnessAddress.trim()) {
                dispatch(updateUiData("witnessFieldIsEmpty", true))
              }
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [
    formRef,
    values,
    thisPageNumber,
    dispatch,
    thisPageClickedNext,
    reviewPageClickedNext,
    witnessList,
    formName,
  ])
  return null
}
export default LossDetails
